module.exports = __webpack_public_path__ + "media/common/images/badges/gray/pali_ti_to-82da3d91bf09f55985bc15b5a3691d63.svg";